/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import { ROUTES } from "@xala/common";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Button } from "../../Button";
import "../../Form/Form.scss";
import "../AuthForm.scss";

export const ForgotPasswordSuccess = () => {
  const { t } = useTranslation();

  return (
    <div className="ForgotPasswordSuccess AuthForm">
      <div className="form">
        <h1>{t("FORGOT_PASSWORD_SUCCESS__TITLE", "Check your email")}</h1>

        <p>
          {t(
            "FORGOT_PASSWORD_SUCCESS__SUBTITLE",
            "If you are an existing user, we will immediately send you an email with a link to reset your password."
          )}
        </p>

        <div className="ButtonLine">
          <Link to={ROUTES.MAIN_SCREEN}>
            <Button buttonClassName="FormButton" type="button">
              {t("FORGOT_PASSWORD_SUCCESS__CONFIRM", "OK")}
            </Button>
          </Link>
        </div>

        <p className="text-center ForgotPasswordSuccessParagraph">
          {t(
            "FORGOT_PASSWORD_SUCCESS__HINT",
            "Can't find the message in your inbox? Check spam."
          )}
        </p>
      </div>
    </div>
  );
};
